'use client';

import React from 'react';
import { motion, useInView } from 'motion/react';
import { Media as MediaProps } from '@/payload-types';
import { Media } from './Media';
import { cn } from '@/utilities/ui';

type ImageRevealProps = {
  image: MediaProps;
  className?: string;
  imgClassName?: string;
};

const ImageReveal = ({ image, className, imgClassName }: ImageRevealProps) => {
  const ref = React.useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.1 });

  if (!image) return null;

  return (
    <section
      ref={ref}
      className="w-full h-full flex items-center justify-center relative  rounded-[inherit]"
    >
      <div className="w-full h-full flex items-center justify-center">
        <div className="relative w-full h-full overflow-hidden">
          <motion.div
            initial={{ width: '100%' }}
            animate={{ width: isInView ? '0%' : '100%' }}
            transition={{
              duration: 0.6,
              ease: 'easeInOut'
            }}
            className="absolute inset-0 bg-card z-10 origin-right rounded-[inherit]"
          />
          <motion.div
            initial={{ scale: 1.6 }}
            animate={{ scale: isInView ? 1 : 1.6 }}
            transition={{
              duration: 1,
              ease: 'easeInOut'
            }}
            className="w-full h-full rounded-[inherit]"
          >
            <Media
              resource={image}
              className={cn(className)}
              imgClassName={cn("w-full h-full object-cover", imgClassName)}
            />
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default ImageReveal;